/**
 * @file formItem label
 * @author zhaomiaoyuan
 */
import React from 'react';
import './index.less';

interface Props {
    isMsgRequired: boolean;
    title: string;
}

export default function LabelFormItem(props: Props) {
    const {
        isMsgRequired,
        title
    } = props;
    return (
        <div className={isMsgRequired ? 'form-label star' : 'form-label'}>
            {title}
        </div>
    );
}
